import { FlexBox, Text } from '@dixa/lib-shared-habla';
import { AnalyticsTier } from 'lib-analytics-types';
import { PropsWithChildren } from 'lib-shared-types-utils';
import capitalize from 'lodash/capitalize';

import { useBreakpointValue } from 'utils/mediaQuery';

import styles from './analyticsHeader.module.scss';

type AnalyticsHeaderProps = {
  tier?: AnalyticsTier;
} & PropsWithChildren;

export const AnalyticsHeader = ({
  tier = 'analytics',
  children,
}: AnalyticsHeaderProps): JSX.Element => {
  const isSmallScreen = useBreakpointValue({ base: true, md: false });

  return (
    <FlexBox
      gap="200"
      alignItems="center"
      padding={isSmallScreen ? '0 0 0 500' : undefined}
      className={styles.header}
    >
      {!isSmallScreen && (
        <Text.Heading color="tertiary" as="h1">
          {capitalize(tier)}
        </Text.Heading>
      )}

      {children}
    </FlexBox>
  );
};
